import { bind, Component, h, signal, tag } from "omi";

import { NWCarouselArrow } from "@/components/base/nw-carousel-arrow";
import { Timeout } from "@/types/timers";
import { NWIcon } from "@/components";
import { tailwind } from "@/tailwind";

import { StudentQuotes } from "../../data";

@tag("nw-testimonial-carousel")
export class NWTestimonialCarousel extends Component {
  static css = [tailwind];
  private currentQuoteIndex = signal(0);
  private cycleInterval: Timeout | undefined;
  private CYCLE_INTERVAL = 7000;

  installed() {
    this.resetInterval();
  }

  uninstall() {
    clearInterval(this.cycleInterval);
  }

  @bind
  private resetInterval() {
    clearInterval(this.cycleInterval);
    this.cycleInterval = setInterval(() => {
      this.cycle("forward");
    }, this.CYCLE_INTERVAL);
  }

  @bind
  private cycle(direction: "forward" | "back") {
    const currentIndex = this.currentQuoteIndex.value;
    this.currentQuoteIndex.value =
      direction === "forward"
        ? (currentIndex + 1) % StudentQuotes.length
        : (currentIndex - 1 + StudentQuotes.length) % StudentQuotes.length;

    this.resetInterval();
  }

  render() {
    const { name, quote, icon, imgUrl } = StudentQuotes[this.currentQuoteIndex.value];

    return (
      <div class="h-full rounded-3xl relative lg:block mx-auto overflow-clip bg-[url('/static/images/student-mosaic.jpg')] w-full bg-cover">
        <div class="p-8 space-y-8 bg-[#0000004d] backdrop-blur-md absolute bottom-0 left-0 transition-all right-0 rounded-b-3xl">
          <h3 class="font-semibold text-xl text-white">"{quote}"</h3>
          <div class="space-y-3">
            <div class="flex items-center space-x-4">
              <div class="relative">
                <img alt="Student avatar" async src={imgUrl} class="w-16 h-16 rounded-full" />
                <NWIcon name={icon} width={20} height={20} class={"rounded-full absolute right-0 bottom-0"} />
              </div>
              <h2 class="text-white font-semibold text-3xl whitespace-nowrap truncate">{name}</h2>
            </div>
            <div class="flex justify-between items-start">
              <p class="text-white">Current NextWork Student</p>
              <div class="space-x-8 text-white">
                <NWCarouselArrow direction="left" onClick={() => this.cycle("back")} />
                <NWCarouselArrow direction="right" onClick={() => this.cycle("forward")} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
